import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Sparkles } from 'lucide-react';
import { Footer } from '../components/Footer';

export function LoginPage() {
    const { isAuthenticated, isLoading, login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <div className="spinner" />
            </div>
        );
    }

    return (
        <div className="login-page">
            {/* Radial glow effect */}
            <div className="login-glow" />

            <div className="login-content">
                <div className="login-card">
                    <img
                        src="/logo.png"
                        alt="AAM Let's Meet"
                        className="login-logo"
                    />

                    <p className="login-description">
                        Schedule meetings with ease. Propose times, collect responses, find the perfect slot.
                    </p>

                    <button
                        onClick={login}
                        className="login-button"
                    >
                        <Sparkles size={20} />
                        Sign in with Insight
                    </button>

                    <p className="login-hint">
                        Use your AAM Group credentials to sign in
                    </p>

                    <div className="login-features">
                        <div className="login-feature">
                            <span className="feature-dot" />
                            Smart Scheduling
                        </div>
                        <div className="login-feature">
                            <span className="feature-dot" />
                            Teams Integration
                        </div>
                        <div className="login-feature">
                            <span className="feature-dot" />
                            CRM Sync
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
